/* FELGER rev3-27-07 · Botón "Ver todas las líneas" (punto 13).
 *
 * El cliente pidió que en Quiénes Somos figuren las 28 líneas del catálogo y
 * que, como no caben todas, haya un botón "Más" que lleve al resto.
 *
 * Mejora progresiva, y el orden importa:
 *   - El markup marca las tarjetas 9-24 del Inicio y las líneas 13-24 de
 *     Nosotros con clases de recorte, y el botón nace con `hidden`.
 *   - Sin JS, el botón permanece oculto y las 28 líneas siguen visibles. Este
 *     script activa el recorte y muestra el botón solo cuando puede expandirlo.
 */
(function () {
  'use strict';

  function iniciar() {
    var bloques = document.querySelectorAll('[data-fg-lineas]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var boton = bloque.querySelector('[data-fg-lineas-mas]');
      var ocultas = bloque.querySelectorAll('.fg-cat--oculta, .fg-linea--oculta');
      if (!boton || !ocultas.length) return;
      if (bloque.dataset.fgLineasInicializada === 'true') return;

      /* Recién acá el recorte se vuelve real: hasta este punto el CSS mostraba
         todo, porque `fg-lineas--recortada` no estaba puesta. */
      bloque.classList.add('fg-lineas--recortada');
      bloque.dataset.fgLineasInicializada = 'true';
      boton.hidden = false;
      boton.setAttribute('aria-expanded', 'false');

      var textoInicial = boton.textContent.trim();

      boton.addEventListener('click', function () {
        var expandida = bloque.classList.toggle('fg-lineas--expandida');
        boton.setAttribute('aria-expanded', String(expandida));
        boton.textContent = expandida ? 'Ver menos' : textoInicial;
        if (expandida) {
          /* Al expandir, mandar el foco a la primera línea recién revelada:
             si no, quien navega por teclado queda perdido arriba. */
          ocultas[0].focus({ preventScroll: true });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
